import React, { Component } from "react";
import { Switch, Redirect } from "react-router-dom";
import { toast } from "react-toastify";

import KeycloakContext from "../../context/keycloakContext";

import Private from "../../routes/private";

import Expire from "../common/expire";
import DashHeader from "./dashboard/dashHeader";
import SideBar from "./dashboard/sideBar";
import Settings from "./settings";
import Overview from "./overview/overview";
import Categories from "./categories";
import CategoryForm from "./categories/categoryForm";
import Tags from "./tags";
import TagFrom from "./tags/tagForm";
import Pois from "./pois";
import PoiForm from "./pois/poiForm";
import Viewpoints from "./viewpoints";
import ViewpointForm from "./viewpoints/viewpointForm";
import Items from "./items";
import ItemForm from "./items/itemForm";
import Tours from "./tours";
import TourFrom from "./tours/tourForm";
import Sections from "./sections";
import SectionForm from "./sections/sectionForm";
import Files from "./files";
import FilesForm from "./files/filesForm";
import Folders from "./folders";
import FolderForm from "./folders/folderForm";

import keycloak from "../../utils/scripts/keycloak";

import { getEntities } from "../../services/apiService";
import { setAccessToken } from "../../services/httpService";

class Dashboard extends Component {
  constructor() {
    super();
    this.initializeTheme = this.initializeTheme.bind(this);

    this.state = {
      setting: "",
      authClient: null,
    };
  }

  async componentDidMount() {
    if (!keycloak.authenticated) {
      // Check if Keycloak is already authenticated
      try {
        const isAuthenticated = await keycloak.init({
          onLoad: "login-required",
        });
        if (isAuthenticated) {
          // Aafter successful authentication
          setAccessToken(keycloak.token);
          this.setState({ authClient: keycloak });
          this.initializeTheme();
        }
      } catch (err) {
        // Error handling
        if (err.error === "access_denied") {
          toast.error("You did not accept the terms of service!");

          setTimeout(() => {
            keycloak.login();
          }, 3000);
        } else {
          toast.error(`Error in Keycloak initialization!`);
        }
      }
    } else {
      // Keycloak is already authenticated
      this.setState({ authClient: keycloak });
      this.initializeTheme();
    }

    // Fetch settings
    const { data } = await getEntities("setting");
    this.setState({ setting: data });
  }

  initializeTheme() {
    const renderSidebar = (toggleId, navId, bodyId, headerId) => {
      const toggle = document.getElementById(toggleId),
        nav = document.getElementById(navId),
        bodypd = document.getElementById(bodyId),
        headerpd = document.getElementById(headerId);

      if (toggle && nav && bodypd && headerpd) {
        toggle.addEventListener("click", () => {
          nav.classList.toggle("show-pd");
          toggle.classList.toggle("bx-x");
          bodypd.classList.toggle("body-pd");
          headerpd.classList.toggle("header-pd");
        });
      }
    };

    renderSidebar("header-toggle", "nav-bar", "body-pd", "header");

    const linkColor = document.querySelectorAll(".nav_link");
    function activateLink() {
      if (linkColor) {
        linkColor.forEach((l) => l.classList.remove("active"));
        this.classList.add("active");
      }
    }

    linkColor.forEach((l) => l.addEventListener("click", activateLink));
  }

  render() {
    if (this.state.authClient)
      return (
        <KeycloakContext.Provider value={this.state.authClient}>
          <div className="body">
            <div id="body-pd">
              <DashHeader />
              <SideBar setting={this.state.setting} />
              <div className="bg-light contain-bg shadow">
                <Switch>
                  <Private
                    exact
                    path="/dashboard/overview"
                    component={Overview}
                  />
                  <Private
                    path="/dashboard/category/:id"
                    component={CategoryForm}
                  />
                  <Private
                    path="/dashboard/categories"
                    component={Categories}
                  />
                  <Private path="/dashboard/tag/:id" component={TagFrom} />
                  <Private path="/dashboard/tags" component={Tags} />
                  <Private path="/dashboard/poi/:id" component={PoiForm} />
                  <Private path="/dashboard/pois" component={Pois} />
                  <Private
                    path="/dashboard/viewpoint/:id"
                    component={ViewpointForm}
                  />
                  <Private
                    path="/dashboard/viewpoints"
                    component={Viewpoints}
                  />
                  <Private path="/dashboard/item/:id" component={ItemForm} />
                  <Private path="/dashboard/items" component={Items} />
                  <Private path="/dashboard/tour/:id" component={TourFrom} />
                  <Private path="/dashboard/tours" component={Tours} />
                  <Private
                    path="/dashboard/section/:id"
                    component={SectionForm}
                  />
                  <Private path="/dashboard/sections" component={Sections} />
                  <Private path="/dashboard/file/:id" component={FilesForm} />
                  <Private path="/dashboard/files" component={Files} />
                  <Private
                    path="/dashboard/folder/:id"
                    component={FolderForm}
                  />
                  <Private path="/dashboard/folders" component={Folders} />
                  <Private path="/dashboard/settings" component={Settings} />
                  <Redirect from="/dashboard" exact to="/dashboard/overview" />
                  <Redirect to="/404" />
                </Switch>
              </div>
            </div>
          </div>
        </KeycloakContext.Provider>
      );

    return (
      <div className="d-flex justify-content-center align-items-center">
        <Expire delay={5000}>
          <div className="loader">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </Expire>
      </div>
    );
  }
}

export default Dashboard;
